import {Component, OnInit, AfterViewInit, Inject, Optional, HostBinding, ViewChild, ElementRef} from '@angular/core';
import { TicketsService } from 'src/app/service/ticket/tickets.service';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { ActivatedRoute } from '@angular/router';
import html2canvas from 'html2canvas';
import {BetType} from '../../service/utility/constant/bettype';
import {ResponsiveService} from '../../service/utility/responsive/responsive.service';
import {MonitoringService} from '../../service/utility/monitoring/monitoring.service';
import {IErrorRequest} from '../../models/error.interface';
import {NguCarouselConfig} from '@ngu/carousel';
import {Observable} from 'rxjs';
import {IIdentify} from '../../models/identify.interface';
import {select, Store} from '@ngrx/store';
import {selectIdentify} from '../../store/selectors/identify.selectors';
import {IAppState} from '../../store/state/app.state';


@Component({
  selector: 'app-detail',
  templateUrl: './detail.component.html',
  styleUrls: ['./detail.component.scss'],
})
export class DetailComponent implements OnInit, AfterViewInit {
  @HostBinding('class') class;
  disableAnimation = true;
  isDialog = true;
  public imgUrl: string;
  environment = environment;
  betType: typeof BetType = BetType;
  public error: IErrorRequest;

  public _identifyObs$: Observable<IIdentify>;

  public combinationSistemi = [];
  public carouselConfig: NguCarouselConfig;

  constructor(
    private route: ActivatedRoute,
    public ticketsService: TicketsService,
    public translateService: TranslateService,
    public dialogWindow: MatDialog,
    public responsiveService: ResponsiveService,
    private appInsightsService: MonitoringService,
    private _store: Store<IAppState>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this._identifyObs$ = this._store.pipe(select(selectIdentify));
    this.imgUrl = environment.imgUrl;
    this.carouselConfig = {
      grid: { xs: 1, sm: 1, md: 1, lg: 1, all: 0 },
      loop: true,
      touch: true,
      velocity: 0.2,
      point: {
        visible: false,
        hideOnSingleSlide: true
      }
    };
  }

  @ViewChild('ticketFrame') ticketFrame: ElementRef;

  ngOnInit() {
    if (!this.data) {
      this.route.queryParams.subscribe((queryParams) => {
        if (queryParams.tID) {
          const css = '/assets/css/ui-print.css';
          this.class = 'dialog-tickets';
          this.isDialog = false;
          this.ticketsService.ticketSelected = queryParams.tID;
          this.ticketsService.sesssionSelected = queryParams.sID !== '' ? queryParams.sID : 'undefined';
          this.ticketsService.retriveDetail().subscribe((detail) => {
            if (!detail.error) {
              this.data = detail;
              this.data.modal = false;
              this.data.cID = queryParams.cID;
            } else {
              this.error = {
                actionNam: 'getDetailTicket',
                message: detail.error.description,
                name: 'Error Ticket',
                ok: false,
                status: detail.ret_code,
                statusText: 'Error Ticket',
                url: '',
              };
            }
          });
          if (!environment.sisalCID.includes(queryParams.cID)) {
            this.appInsightsService.createLink(css);
          }
        }
      });
      // here pass dialog data to the child component
    }
  }

  ngAfterViewInit(): void {
    // timeout required to avoid the dreaded 'ExpressionChangedAfterItHasBeenCheckedError'
    setTimeout(() => (this.disableAnimation = false));

    // Create img to html if tIMG queryParams is set
    setTimeout(() => {
      this.route.queryParams.subscribe((queryParams) => {
        if (queryParams.tID && queryParams.tIMG) {
            html2canvas(this.ticketFrame.nativeElement).then(canvas => {
            document.write(canvas.toDataURL('image/png'));
          });
        }
      });
    }, 100);
  }

  partnerIdentify(token): any {
    if (environment.sksCID.includes(token)) {
      return 'sks-content';
    }
    if (environment.parimCID.includes(token)) {
      return 'parim-content';
    }
    if (environment.quigiocoCID.includes(token)) {
      return 'quigioco-content';
    }
    if (environment.youbetCID.includes(token)) {
      return 'youbet-content';
    }
    if (environment.trebetCID.includes(token)) {
      return 'trebet-content';
    }
    if (environment.bet2020CID.includes(token)) {
      return 'bet2020-content';
    }
  }

  btnCombination(ticket, sistema) {
    this.ticketsService.getCombinationSistemi(ticket, sistema).subscribe((comb) => {
      if (comb) {
        this.combinationSistemi = comb;
      }
    });
  }

  closeCombination() {
    this.combinationSistemi = [];
  }


  numberHorse(ia, esito) {

    if (esito === '1') {
      return String( parseInt('0x' + ia.substr(6, 2)));
    } else {
      return String( parseInt('0x' + ia.substr(4, 2)));
    }
  }

  truncateDecimal(num) {
    return Number(num.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]);
  }

  columInfoSisal() {
    if (this.responsiveService.extraExtraSmallSize.matches) {
      return 1;
    }
    return 2;
  }

  excludeViewEsito(scommessa) {
    return scommessa !== '14' &&
        scommessa !== '16' &&
        scommessa !== '18' &&
        scommessa !== '22' &&
        scommessa !== '23' &&
        scommessa !== '24';
  }
}
